import React, { useState, useEffect } from "react";
import "./exceptions.css";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import Swal from "sweetalert2";
import axios from "axios";
// 1. Importamos los componentes de Bootstrap necesarios
import { Modal, Spinner } from "react-bootstrap";

function Exceptions() {
  const [masterGuide, setMasterGuide] = useState("");
  const [error, setError] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [showSaveButton, setShowSaveButton] = useState(false);
  const [houses, setHouses] = useState([]);
  const [selectedHouse, setSelectedHouse] = useState("");
  const [errorMaster, setErrorMaster] = useState("");
  const [conceptoDisplayNames, setConceptoDisplayNames] = useState([]);
  const [excTypes, setExcTypes] = useState([]);
  const [currencies, setCurrencies] = useState([]);

  // 2. Estado para controlar el Loader
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_exceptions`,
          { master: masterGuide },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        const charges = res.data.data.excCharges;
        const namesMapping = {};
        charges.forEach((item) => {
          namesMapping[item.id] = item.name;
        });
        setConceptoDisplayNames(namesMapping);

        const exc_types = res.data.data.excTypes;
        const namesMappingExcTypes = {};
        exc_types.forEach((item) => {
          namesMappingExcTypes[item.id] = item.name;
        });
        setExcTypes(namesMappingExcTypes);

        const res_currencies = res.data.data.currencies;
        const namesMappingCurrencies = {};
        res_currencies.forEach((item) => {
          namesMappingCurrencies[item.id] = item.name;
        });
        setCurrencies(namesMappingCurrencies);
      } catch (err) {
        setError(err.message);
      } finally {
      }
    };

    fetchData();
  }, []);

  const fetchHousesSimulado = async (guide) => {
    try {
      setErrorMaster("");
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_exceptions/getHouses`,
        { master: masterGuide },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        if (res.data.data == "No houses") {
          setHouses(["N/A"]);
        } else {
          const arrayData = Object.entries(res.data.data).map(
            ([key, value]) => ({
              id: key,
              guia: value,
            })
          );
          setHouses(arrayData);
        }
      } else if (res.data.code === -1) {
        setErrorMaster("La master no existe favor de verificar");
        setHouses(["N/A"]);
        return;
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Hubo un error inesperado",
        icon: "error",
        iconColor: "#f90034}",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
      setHouses(["N/A"]);
    }
  };

  const handleSearch = async () => {
    setShowTable(false);
    setShowSaveButton(false);
    if (!masterGuide) {
      setError("Por favor ingresa una guía master.");
      setShowTable(false);
      setShowSaveButton(false);
      return;
    }

    // 3. Activamos el Loader antes de buscar
    setLoading(true);

    try {
      setErrorMaster("");
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_exceptions/getExceptions`,
        { master: masterGuide, house: selectedHouse },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        setShowTable(true);
        // Esperamos a que se pinte la tabla y se llenen los datos antes de quitar el loader
        setTimeout(() => {
          cargarExcepcionesGuardadas(res.data.data);
          setLoading(false); // Desactivamos Loader aquí
        }, 50);
        setError("");
        setShowSaveButton(true);
      } else if (res.data.code === -1) {
        setLoading(false); // Desactivamos Loader en error controlado
        Swal.fire({
          title: "Hubo un error inesperado",
          icon: "error",
          iconColor: "#f90034}",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      }
    } catch (error) {
      setLoading(false); // Desactivamos Loader en catch
      console.error(error);
      Swal.fire({
        title: "Hubo un error inesperado",
        icon: "error",
        iconColor: "#f90034}",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
    }
  };

  const cargarExcepcionesGuardadas = (dataSaved) => {
    if (!dataSaved || !Array.isArray(dataSaved)) return;

    dataSaved.forEach((item) => {
      const charId = item.exception_charge_id;
      const checkMaestro = document.getElementById(`act_${charId}`);
      if (checkMaestro) {
        checkMaestro.checked = true;

        const valInput = document.getElementById(`value_${charId}`);
        const typeInput = document.getElementById(`exc_type_${charId}`);
        const currInput = document.getElementById(`curr_${charId}`);
        const thirdPartyInput = document.getElementById(
          `is_third_party_${charId}`
        );

        if (valInput) valInput.value = item.value || "";
        if (typeInput) typeInput.value = item.exception_type_id || "";
        if (currInput) currInput.value = item.currency_id || "";

        if (thirdPartyInput) {
          thirdPartyInput.checked = item.is_third_party === 1;
        }

        const targets = document.querySelectorAll(`.disabled_${charId}`);
        targets.forEach((el) => {
          el.disabled = false;
        });
      }
    });
  };

  const handleGuardar = async () => {
    const payload = [];
    let errorValidacion = false;

    const checkboxesActivos = document.querySelectorAll(
      'input[class*="main_checkbox_"]:checked'
    );
    let missingFields = [];
    checkboxesActivos.forEach((checkbox) => {
      const id = checkbox.getAttribute("data-id");

      const typeElement = document.getElementById(`exc_type_${id}`);
      const valueElement = document.getElementById(`value_${id}`);
      const currElement = document.getElementById(`curr_${id}`);
      const thirdPartyElement = document.getElementById(`is_third_party_${id}`);

      const type = typeElement ? typeElement.value : "";
      const value = valueElement ? valueElement.value.trim() : "";
      const currency = currElement ? currElement.value : "";
      const isThirdParty = thirdPartyElement
        ? thirdPartyElement.checked
        : false;

      if (!type || !value || !currency) {
        /* alert(`Faltan datos obligatorios para: ${conceptoDisplayNames[id]}`); */
        missingFields.push(conceptoDisplayNames[id]);
        Swal.fire({
          title: "Faltan datos",
          text: `Faltan datos obligatorios para: ${missingFields.join(", ")}`,
          icon: "error",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
        errorValidacion = true;
        return;
      }

      payload.push({
        charge_id: id,
        type: type,
        value: parseFloat(value),
        currency: currency,
        is_third_party: isThirdParty,
      });
    });

    if (errorValidacion) return;

    if (payload.length === 0) {
      Swal.fire({
        text: "No se ha seleccionado ningún cargo para guardar.",
        icon: "warning",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
      return;
    }

    // 4. Activamos el Loader antes de guardar
    setLoading(true);

    try {
      setErrorMaster("");
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_exceptions/saveExceptions`,
        { master: masterGuide, house: selectedHouse, data_save: payload },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      // Desactivamos el loader independientemente del resultado dentro del try
      setLoading(false);

      if (res.data.code === 1) {
        Swal.fire({
          title: "Guardado exitosamente",
          icon: "success",
          iconColor: "#f90034}",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      } else if (res.data.code === -1) {
        Swal.fire({
          title: "Hubo un error inesperado",
          icon: "error",
          iconColor: "#f90034}",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      }
    } catch (error) {
      setLoading(false); // Desactivamos Loader en catch
      console.error(error);
      Swal.fire({
        title: "Hubo un error inesperado",
        icon: "error",
        iconColor: "#f90034}",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
    }
  };
// Función MEJORADA para manejar cambios en el INPUT de valor
  const handleValueChange = (e, id) => {
    // 1. Limpieza: solo números y un solo punto decimal
    let val = e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1");

    // 2. Buscamos el select asociado
    const typeSelect = document.getElementById(`exc_type_${id}`);
    
    if (typeSelect && typeSelect.selectedIndex >= 0) {
      const selectedOption = typeSelect.options[typeSelect.selectedIndex];
      const selectedText = selectedOption.text.toLowerCase(); // Convertimos a minúsculas

      console.log(`Fila ${id} - Tipo seleccionado:`, selectedText); // <--- MIRA LA CONSOLA SI FALLA

      // 3. Verificamos si es porcentaje (buscamos la palabra O el símbolo %)
      // Ajusta estas palabras según lo que realmente sale en tu select
      if (selectedText.includes("porcentaje") || selectedText.includes("%")) {
        const numVal = parseFloat(val);

        if(numVal === 0) {
          val = "";
        }
        
        // Si es mayor a 100, lo regresamos a 100
        if (!isNaN(numVal) && numVal > 100) {
          val = "100";
        }
      }
    }
    
    // 4. Importante: Forzamos la actualización visual
    e.target.value = val;
  };

  // Función MEJORADA para manejar cambios en el SELECT de tipo
  const handleTypeSelectChange = (e, id) => {
    const valInput = document.getElementById(`value_${id}`);
    
    // Si hay un select válido y hay un input con valor
    if (valInput && valInput.value && e.target.selectedIndex >= 0) {
      const selectedText = e.target.options[e.target.selectedIndex].text.toLowerCase();
      
      console.log(`Cambio de tipo en fila ${id}:`, selectedText);

      // Si cambiaron a porcentaje y el valor actual excede 100, corregir
      if (selectedText.includes("porcentaje") || selectedText.includes("%")) {
        const currentVal = parseFloat(valInput.value);
        if (!isNaN(currentVal) && currentVal > 100) {
          valInput.value = "100";
        }
      }
    }
  };

  const formatValue = (value) => {
    let raw = value.replace(/[^0-9]/g, "");
    if (raw.length > 11) raw = raw.slice(0, 11);

    let formatted = raw;
    if (raw.length > 3) {
      formatted = raw.slice(0, 3) + "-" + raw.slice(3);
    }
    return { raw, formatted };
  };

  const handleCheckChange = (element) => {
    const dataId = element.getAttribute("data-id");
    const isChecked = element.checked;
    const targets = document.querySelectorAll(`.disabled_${dataId}`);

    targets.forEach((target) => {
      target.disabled = !isChecked;
    });
  };

  return (
    <>
      <Helmet>
        <title>Horus | Excepciones</title>
      </Helmet>
      <ScrollToTop />

      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-8">
            <div className="row">
              <div className="col-md-6">
                <label htmlFor="inputMaster" className="amc-label">
                  Guía Master
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="inputMaster"
                  value={masterGuide}
                  onChange={(e) => {
                    const { formatted } = formatValue(e.target.value);
                    setMasterGuide(formatted);
                  }}
                  onKeyUp={(e) => {
                    const { raw, formatted } = formatValue(e.target.value);

                    if (raw.length >= 10) {
                      fetchHousesSimulado(formatted);
                    }
                  }}
                />
                {errorMaster && (
                  <div
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  >
                    {errorMaster}
                  </div>
                )}
              </div>

              <div className="col-md-6">
                <label htmlFor="selectHouse" className="amc-label">
                  Guía House
                </label>
                <select
                  id="selectHouse"
                  className="form-select"
                  value={selectedHouse}
                  onChange={(e) => setSelectedHouse(e.target.value)}
                >
                  {houses.length === 0 ? (
                    <option value="" disabled>
                      Cargando...
                    </option>
                  ) : houses[0] === "N/A" ? (
                    <option value="N/A">N/A</option>
                  ) : (
                    <>
                      <option value="" disabled>
                        Selecciona house...
                      </option>
                      {houses.map((house) => (
                        <option key={house.id} value={house.id}>
                          {house.guia}
                        </option>
                      ))}
                    </>
                  )}
                </select>
              </div>
            </div>

            <div className="btns mt-3 d-flex justify-content-end gap-3">
              <button className="btnn" onClick={handleSearch}>
                Buscar
              </button>
            </div>
          </div>

          {showTable && (
            <div className="col-md-12 mt-4">
              <table className="table fondo-headBilling">
                <thead>
                  <tr className="text-center">
                    <th>Concepto</th>
                    <th>Excepción</th>
                    <th>Tipo excepción</th>
                    <th>Cantidad</th>
                    <th>Moneda</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(conceptoDisplayNames).map(([id, name]) => (
                    <tr key={id} className="border-b">
                      <td className="">{name}</td>
                      <td className="p-2 text-center">
                        <input
                          type="checkbox"
                          className={`form-check-input main_checkbox_`}
                          id={`act_${id}`}
                          data-id={id}
                          value={id}
                          onChange={(e) => handleCheckChange(e.target)}
                        />
                      </td>
                      {/* Columna de Tipo Excepción */}
                      <td className="">
                        <select
                          className={`form-select disabled_${id}`}
                          id={`exc_type_${id}`}
                          disabled
                          // AGREGAMOS ESTO: Cuando cambie el tipo, valida el valor existente
                          onChange={(e) => handleTypeSelectChange(e, id)} // <--- NUEVO
                        >
                          <option value="" disabled selected>
                            Selecciona...
                          </option>
                          {Object.entries(excTypes).map(([id_excTypes, name_excTypes]) => (
                            <option key={id_excTypes} value={id_excTypes}>
                              {name_excTypes}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td className="">
                        <input
                          type="text"
                          className={`form-control disabled_${id}`}
                          id={`value_${id}`}
                          disabled
                          // SUSTITUIMOS EL onInput ANTERIOR POR LA NUEVA FUNCIÓN
                          onInput={(e) => handleValueChange(e, id)} // <--- NUEVO
                        />
                      </td>
                      <td className="">
                        {id == 15 ? (
                          <div className="row">
                            <div className="col-md-6">
                              <select
                                className={`form-select disabled_${id}`}
                                id={`curr_${id}`}
                                disabled
                              >
                                <option value="" disabled selected>
                                  Selecciona...
                                </option>
                                {Object.entries(currencies).map(
                                  ([id_currencies, name_currencies]) => (
                                    <option
                                      key={id_currencies}
                                      value={id_currencies}
                                    >
                                      {name_currencies}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                            <div className="col-md-6">
                              <div className="d-flex align-items-center gap-2">
                                <label
                                  className="form-check-label"
                                  for={`is_third_party_${id}`}
                                >
                                  ¿Precio terceros?
                                </label>
                                <input
                                  id={`is_third_party_${id}`}
                                  type="checkbox"
                                  className={`disabled_${id}`}
                                  value="1"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <select
                            className={`form-select disabled_${id}`}
                            disabled
                            id={`curr_${id}`}
                          >
                            <option value="" disabled selected>
                              Selecciona...
                            </option>
                            {Object.entries(currencies).map(
                              ([id_currencies, name_currencies]) => (
                                <option
                                  key={id_currencies}
                                  value={id_currencies}
                                >
                                  {name_currencies}
                                </option>
                              )
                            )}
                          </select>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {showSaveButton && (
            <div className="btns mt-3 d-flex justify-content-end gap-3">
              <button className="btnn" onClick={handleGuardar}>
                Guardar
              </button>
            </div>
          )}
        </div>
      </div>

      {/* 5. Componente Modal Loader agregado aquí */}
      <Modal
        show={loading}
        onHide={() => setLoading(false)}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal"
        backdropClassName="custom-backdrop"
      >
        <div className="spinner-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      </Modal>
    </>
  );
}

export default Exceptions;